export default "__VITE_ASSET__e0c65638__"